<template>
  <div v-if="loaded" class="print-main">
    <div class="print-left" :style="{ height: `${this.$util.getViewHeight() - 162}px` }">
      <div id="print-content" class="print-content">
        <!-- title -->
        <div class="title-box">
          <h1 class="title-main">{{ $constant.company_info.company_name }}</h1>
          <div class="m-t-5">联系地址：{{ $constant.company_info.company_address }}</div>
          <div class="m-t-5">联系电话：{{ $constant.company_info.company_phone }}</div>
          <h2 class="title-sub">
            生产订单
            <span class="title-number">
              <span>NO.</span>
              <span class="title-red">{{ detailData.report_bill.bill_code }}</span>
            </span>
          </h2>
        </div>

        <!-- formData -->
        <div class="form-main">
          <div class="form-list" v-for="(itemSt, indexSt) in formData" :key="indexSt">
            <div
              :class="{ 'form-item': true, 'form-st': !indexNd }"
              v-for="(itemNd, indexNd) in itemSt"
              :key="indexNd"
            >
              <div class="form-key">{{ itemNd.key }}{{ itemNd.key && '：' }}</div>
              <div class="form-val" v-if="itemNd.val">
                <span v-if="itemNd.val === 'bill_date' || itemNd.val === 'jiao_huo_ri_qi'">
                  {{
                    detailData.report_bill[itemNd.val]
                      ? detailData.report_bill[itemNd.val].slice(0, 10)
                      : '&nbsp;'
                  }}
                </span>
                <span v-else>
                  {{ detailData.report_bill[itemNd.val] || '&nbsp;' }}
                </span>
                <span
                  v-if="itemNd.val === 'company_id' && detailData.report_bill.customer_rating"
                  class="c-red"
                  >({{ detailData.report_bill.customer_rating }})</span
                >
              </div>
            </div>
          </div>
        </div>

        <!-- tableData -->
        <div class="table-main">
          <div class="f-bold">销售清单</div>
          <PrintTable :data="detailData.stock_list" />
        </div>

        <!-- 签章 -->
        <div class="gai-zhang-box">
          <div class="gai-zhang-cont">
            <div class="gai-zhang-item">财务(签章)：</div>
            <div class="gai-zhang-item">日期：</div>
          </div>
          <div class="gai-zhang-cont">
            <div class="gai-zhang-item">工程师(签章)：</div>
            <div class="gai-zhang-item">日期：</div>
          </div>
          <div class="gai-zhang-cont">
            <div class="gai-zhang-item">生产总监(签章)：</div>
            <div class="gai-zhang-item">日期：</div>
          </div>
          <div class="gai-zhang-cont">
            <div class="gai-zhang-item">总经理(签章)：</div>
            <div class="gai-zhang-item">日期：</div>
          </div>
        </div>
      </div>
    </div>
    <div class="print-right">
      <div class="print-do">
        <div>
          <el-button class="print-btn" v-print="printData" type="primary" size="small">
            打印
          </el-button>
        </div>
        <div class="m-t-10">
          <el-button class="print-btn" type="default" size="small" @click="jumpEdit">
            编辑
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PrintTable: () => import('./print-table')
  },
  data() {
    return {
      loaded: false,
      detailData: {},
      printData: {
        id: 'print-content',
        popTitle: '&nbsp;'
      },
      formData: [
        [
          {
            key: '销售单号',
            val: 'bill_code'
          },
          {
            key: '客户',
            val: 'company_id'
          },
          {
            key: '业务员',
            val: 'saler'
          },
          {
            key: '联系电话',
            val: 'saler_phone'
          }
        ],
        [
          {
            key: '销售日期',
            val: 'bill_date'
          },
          {
            key: '开单公司',
            val: 'saler_company_name'
          },
          {
            key: '交货日期',
            val: 'jiao_huo_ri_qi'
          },
          {
            key: '优先级',
            val: 'field_empty'
          }
        ]
      ]
    }
  },
  computed: {
    billId() {
      return this.$route.query.id
    }
  },
  mounted() {
    this.getDetailData()
  },
  methods: {
    // 获取详情数据
    getDetailData() {
      this.loaded = false
      this.$api({
        method: 'get',
        url: '/admin/gcvip/reportBill/detail',
        params: {
          id: this.billId
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.detailData = this.$util.deepCopy(res.data)
          }
        })
        .catch(() => {})
        .then(() => {
          this.loaded = true
        })
    },
    // 跳转到编辑
    jumpEdit() {
      this.$router.push(`/sale/quote/detail?id=${this.billId}`)
    }
  }
}
</script>

<style lang="less" scoped>
// print
.print-main {
  display: flex;
  background: #f5f7fa;
  .print-left {
    margin: 10px;
    padding: 20px;
    width: 712px;
    background: #fff;
    overflow-y: auto;
    .scroll-bar();
  }
  .print-right {
    margin: 10px 10px 10px 0;
    padding: 10px;
    width: 200px;
    background: #fff;
    .print-btn {
      width: 100%;
    }
    .print-do {
      margin-bottom: 20px;
      padding: 20px;
      text-align: center;
      font-size: 14px;
      background: #f8f8f8;
    }
  }
}

// content
.print-content {
  font-size: 12px;
  line-height: 1.5;
  font-family: 'Arial,Microsoft YaHei,SimHei,SimSun';
  overflow: hidden;
}

// title
.title-box {
  margin: 10px 0 30px 0;
  text-align: center;
}
.title-main {
  margin: 0;
  font-size: 24px;
}
.title-sub {
  position: relative;
  margin: 20px 0 0 0;
  font-size: 20px;
}
.title-number {
  position: absolute;
  top: 0;
  right: 0;
}
.title-red {
  color: #cf2438;
}

// form
.form-main {
  display: flex;
  margin-top: 20px;
}
.form-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  & ~ .form-list {
    margin-left: 10px;
  }
  .form-item {
    flex: 1;
    display: flex;
    align-items: center;
    &.form-st {
      font-weight: bold;
    }
    .form-key {
      border-bottom: 1px solid #fff;
    }
    .form-val {
      flex: 1;
      padding: 2px 0;
      border-bottom: 1px solid #000;
    }
  }
}

// table
.table-main {
  margin: 20px 0;
}

.gai-zhang-box {
  display: flex;
  margin-top: 40px;
  padding-top: 20px;
  font-size: 14px;
  border-top: 1px solid #000;
  .gai-zhang-cont {
    text-align: right;
    & ~ .gai-zhang-cont {
      margin-left: 90px;
    }
    .gai-zhang-item {
      & ~ .gai-zhang-item {
        margin-top: 10px;
      }
    }
  }
}
</style>
